<template>
  <admin-page-frame>
    <school-list-toolbar @search="loadList" @reset="handleReset">
      <template #actions>
        <el-button class="filter-item" type="primary" size="mini" icon="el-icon-plus" @click="openCreate">新建报名</el-button>
      </template>
      <template #filters>
        <el-select v-model="query.status" clearable size="small" placeholder="订单状态" class="filter-item" style="width: 160px; margin-right: 10px;">
          <el-option label="草稿" value="draft" /><el-option label="待到校缴费" value="pending_offline_pay" /><el-option label="已生效" value="active" />
          <el-option label="已取消" value="cancelled" /><el-option label="退课中" value="refunding" /><el-option label="已退费" value="refunded" />
        </el-select>
        <el-input v-model="query.keyword" clearable size="small" placeholder="订单号" class="filter-item" style="width: 180px; margin-right: 10px;" @keyup.enter.native="loadList" />
        <el-date-picker v-model="dateRange" type="daterange" size="small" range-separator="至" start-placeholder="创建开始" end-placeholder="创建结束" value-format="yyyy-MM-dd" class="filter-item" style="margin-right: 10px;" />
      </template>
    </school-list-toolbar>
    <el-table v-loading="loading" :data="list" :border="false" size="small" style="width: 100%;">
      <el-table-column prop="orderNo" label="订单号" min-width="160" show-overflow-tooltip />
      <el-table-column prop="studentId" label="学员ID" width="90" />
      <el-table-column prop="classId" label="班级ID" width="90" />
      <el-table-column prop="totalAmount" label="应收金额" width="100" align="right" />
      <el-table-column prop="paidAmount" label="已收金额" width="100" align="right" />
      <el-table-column label="状态" width="110" align="center"><template slot-scope="{ row }"><el-tag size="mini">{{ orderStatusLabel(row.status) }}</el-tag></template></el-table-column>
      <el-table-column prop="createTime" label="创建时间" min-width="150" />
      <el-table-column label="操作" min-width="120" width="120" align="center" fixed="right" class-name="admin-pc-table-actions-col">
        <template slot-scope="{ row }"><div class="admin-pc-table-actions"><el-button v-if="canConfirmPayment(row)" type="text" size="mini" @click="openPayment(row)">确认收款</el-button><span v-else style="color: #c0c4cc;">-</span></div></template>
      </el-table-column>
    </el-table>
    <school-list-pagination :total="total" :page="query.page" :size="query.size" @page-change="onPageChange" @size-change="onSizeChange" />

    <el-dialog title="新建报名" :visible.sync="createVisible" width="560px" :close-on-click-modal="false" @closed="resetCreate">
      <el-form ref="createRef" :model="createForm" :rules="createRules" label-width="90px" size="small">
        <el-form-item label="学员" prop="studentId">
          <el-select v-model="createForm.studentId" filterable remote :remote-method="searchStudents" placeholder="搜索姓名/学号/手机" style="width: 100%;">
            <el-option v-for="s in studentOptions" :key="s.id" :label="s.studentName + '（' + s.studentCode + '）'" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="课程" prop="courseId">
          <el-select v-model="createForm.courseId" filterable style="width: 100%;" @change="onCreateCourseChange">
            <el-option v-for="c in courseOptions" :key="c.id" :label="c.courseName" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="课包">
          <el-select v-model="createForm.packageId" clearable filterable style="width: 100%;" @change="onCreatePackageChange">
            <el-option v-for="p in packageOptions" :key="p.id" :label="packageLabel(p)" :value="p.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="购买课时"><el-input-number v-model="createForm.paidLessonCount" :min="0" style="width: 100%;" /></el-form-item>
        <el-form-item label="赠送课时"><el-input-number v-model="createForm.giftLessonCount" :min="0" style="width: 100%;" /></el-form-item>
        <el-form-item label="应收金额" prop="amount"><el-input-number v-model="createForm.amount" :min="0" :precision="2" style="width: 100%;" /></el-form-item>
        <el-form-item label="班级">
          <el-select v-model="createForm.classId" clearable filterable placeholder="可选" style="width: 100%;">
            <el-option v-for="c in classOptionsForCourse" :key="c.id" :label="c.className" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="createForm.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="createVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="creating" @click="submitCreate(false)">保存草稿</el-button>
        <el-button type="success" size="small" :loading="creating" @click="submitCreate(true)">保存并收款</el-button>
      </div>
    </el-dialog>

    <el-dialog title="确认线下收款" :visible.sync="paymentVisible" width="480px" :close-on-click-modal="false" @closed="resetPayment">
      <el-form ref="paymentRef" :model="paymentForm" :rules="paymentRules" label-width="90px" size="small" class="admin-pc-dialog-form">
        <el-form-item label="订单号"><span>{{ paymentForm.orderNo }}</span></el-form-item>
        <el-form-item label="应收金额"><span>{{ paymentForm.totalAmount }}</span></el-form-item>
        <el-form-item label="收款金额" prop="amount"><el-input-number v-model="paymentForm.amount" :min="0" :precision="2" :step="100" style="width: 100%;" /></el-form-item>
        <el-form-item label="收款方式" prop="payChannel"><el-select v-model="paymentForm.payChannel" style="width: 100%;"><el-option label="现金" value="cash" /><el-option label="转账" value="transfer" /><el-option label="POS" value="pos" /></el-select></el-form-item>
        <el-form-item label="备注"><el-input v-model="paymentForm.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer"><el-button size="small" @click="paymentVisible = false">取消</el-button><el-button type="primary" size="small" :loading="paying" @click="submitPayment">确认收款</el-button></div>
    </el-dialog>
  </admin-page-frame>
</template>
<script>
import AdminPageFrame from './components/AdminPageFrame.vue'
import SchoolListToolbar from './components/SchoolListToolbar.vue'
import SchoolListPagination from './components/SchoolListPagination.vue'
import schoolListPageMixin from './mixins/school-list-page'
import {
  confirmSchoolEnrollPayment,
  createSchoolEnrollOrder,
  fetchSchoolClasses,
  fetchSchoolCourseDetail,
  fetchSchoolCourseOptions,
  fetchSchoolEnrollOrders,
  fetchSchoolStudents
} from '@/api/h5-admin-schools'
import './schools-admin.less'
const DEFAULT_QUERY = { status: null, keyword: '', page: 0, size: 20 }
export default {
  name: 'SchoolsEnroll',
  components: { AdminPageFrame, SchoolListToolbar, SchoolListPagination },
  mixins: [schoolListPageMixin],
  data() {
    return {
      loading: false, paying: false, creating: false, list: [], total: 0, dateRange: null, query: { ...DEFAULT_QUERY },
      courseOptions: [], packageOptions: [], classOptions: [], studentOptions: [],
      createVisible: false, paymentVisible: false,
      createForm: { studentId: null, courseId: null, packageId: null, paidLessonCount: 0, giftLessonCount: 0, amount: 0, classId: null, remark: '' },
      createRules: {
        studentId: [{ required: true, message: '请选择学员', trigger: 'change' }],
        courseId: [{ required: true, message: '请选择课程', trigger: 'change' }],
        amount: [{ required: true, message: '请填写金额', trigger: 'change' }]
      },
      paymentForm: { orderNo: '', totalAmount: 0, amount: 0, payChannel: 'cash', remark: '' },
      paymentRules: {
        amount: [{ required: true, message: '请输入收款金额', trigger: 'change' }],
        payChannel: [{ required: true, message: '请选择收款方式', trigger: 'change' }]
      }
    }
  },
  computed: {
    classOptionsForCourse() {
      if (!this.createForm.courseId) return this.classOptions
      return this.classOptions.filter(c => c.courseId === this.createForm.courseId)
    }
  },
  created() { this.loadOptions(); this.loadList() },
  methods: {
    loadOptions() {
      fetchSchoolCourseOptions().then(list => { this.courseOptions = list || [] })
      fetchSchoolClasses({ page: 0, size: 200 }).then(res => { this.classOptions = (res && res.content) || [] })
    },
    searchStudents(keyword) {
      if (!keyword) return
      fetchSchoolStudents({ keyword, page: 0, size: 20 }).then(res => { this.studentOptions = (res && res.content) || [] })
    },
    packageLabel(p) { return (p.packageName || '课包') + '（' + (p.lessonCount || 0) + '课时）' },
    handleReset() { this.dateRange = null; this.resetListQuery(DEFAULT_QUERY) },
    orderStatusLabel(v) { const map = { draft: '草稿', pending_offline_pay: '待到校缴费', active: '已生效', cancelled: '已取消', refunding: '退课中', refunded: '已退费' }; return map[v] || v || '-' },
    canConfirmPayment(row) { return row && ['draft', 'pending_offline_pay'].includes(row.status) },
    inDateRange(createTime) { if (!this.dateRange || !this.dateRange.length) return true; if (!createTime) return false; const day = String(createTime).substring(0, 10); return day >= this.dateRange[0] && day <= this.dateRange[1] },
    loadList() {
      this.loading = true
      const hasDateFilter = this.dateRange && this.dateRange.length === 2
      const params = { status: this.query.status || undefined, keyword: this.query.keyword || undefined, page: hasDateFilter ? 0 : this.query.page, size: hasDateFilter ? 500 : this.query.size }
      fetchSchoolEnrollOrders(params).then(res => {
        let list = (res && res.content) || []
        if (hasDateFilter) { list = list.filter(r => this.inDateRange(r.createTime)); this.total = list.length; const start = this.query.page * this.query.size; list = list.slice(start, start + this.query.size) }
        else { this.total = (res && res.totalElements) || 0 }
        this.list = list
      }).finally(() => { this.loading = false })
    },
    openCreate() { this.createVisible = true },
    resetCreate() {
      this.packageOptions = []
      this.createForm = { studentId: null, courseId: null, packageId: null, paidLessonCount: 0, giftLessonCount: 0, amount: 0, classId: null, remark: '' }
      this.$nextTick(() => this.$refs.createRef && this.$refs.createRef.clearValidate())
    },
    onCreateCourseChange(courseId) {
      this.createForm.packageId = null
      this.createForm.classId = null
      this.packageOptions = []
      if (!courseId) return
      fetchSchoolCourseDetail(courseId).then(res => { this.packageOptions = (res && res.packages) || [] })
    },
    onCreatePackageChange(packageId) {
      const pkg = this.packageOptions.find(p => p.id === packageId)
      if (!pkg) return
      this.createForm.paidLessonCount = pkg.lessonCount || 0
      this.createForm.giftLessonCount = pkg.giftLessonCount || 0
      this.createForm.amount = pkg.listPrice || 0
    },
    submitCreate(withPay) {
      this.$refs.createRef.validate(valid => {
        if (!valid) return
        this.creating = true
        const item = {
          packageId: this.createForm.packageId,
          courseId: this.createForm.courseId,
          packageName: this.createForm.packageId ? undefined : '报名课时',
          lessonCount: this.createForm.paidLessonCount,
          giftLessonCount: this.createForm.giftLessonCount,
          amount: this.createForm.amount
        }
        const payload = {
          studentId: this.createForm.studentId,
          classId: this.createForm.classId,
          orderType: 'new',
          remark: this.createForm.remark,
          totalAmount: this.createForm.amount,
          items: [item]
        }
        createSchoolEnrollOrder(payload).then(res => {
          if (!withPay) {
            this.$message.success('草稿已保存')
            this.createVisible = false
            this.loadList()
            return
          }
          const orderNo = res.orderNo
          return confirmSchoolEnrollPayment(orderNo, { amount: this.createForm.amount, payChannel: 'cash', remark: this.createForm.remark }).then(() => {
            this.$message.success('报名并收款成功')
            this.createVisible = false
            this.loadList()
          })
        }).finally(() => { this.creating = false })
      })
    },
    openPayment(row) { this.paymentForm = { orderNo: row.orderNo, totalAmount: row.totalAmount, amount: row.totalAmount, payChannel: 'cash', remark: '' }; this.paymentVisible = true },
    resetPayment() { this.paymentForm = { orderNo: '', totalAmount: 0, amount: 0, payChannel: 'cash', remark: '' }; this.$nextTick(() => this.$refs.paymentRef && this.$refs.paymentRef.clearValidate()) },
    submitPayment() {
      this.$refs.paymentRef.validate(valid => {
        if (!valid) return
        this.$confirm('确认登记线下收款并激活课时账户？', '提示', { type: 'warning' }).then(() => {
          this.paying = true
          confirmSchoolEnrollPayment(this.paymentForm.orderNo, { amount: this.paymentForm.amount, payChannel: this.paymentForm.payChannel, remark: this.paymentForm.remark }).then(() => { this.$message.success('收款确认成功'); this.paymentVisible = false; this.loadList() }).finally(() => { this.paying = false })
        }).catch(() => {})
      })
    }
  }
}
</script>
